/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModFlexwijerNews: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 15H1V2.415L1.705 1.705L2 1.415L3 2.415L3.705 1.705L4 1.415L5 2.415L6 1.415L7 2.415L8 1.415L9 2.415L10 1.415L11 2.415L12 1.415L13 2.415L14 1.415L15 2.415V15ZM15 1L14 0L13 1L12 0L11 1L10 0L9 1L8 0L7 1L6 0L5 1L4 0L3 1L2 0L1 1L0 0V15C0 15.553 0.448 16 1 16H15C15.553 16 16 15.553 16 15V0L15 1ZM2.0004 6H14.0004V4H2.0004V6ZM2.0004 13H7.0004V8H2.0004V13ZM9.0004 9H14.0004V8H9.0004V9ZM9.0004 13H14.0004V12H9.0004V13ZM9.0004 11H14.0004V10H9.0004V11Z'
			/>
		</Svg>
	);
};

export { ModFlexwijerNews };
